module.exports = __webpack_public_path__ + "static/img/product_images_35_h5_zh.00a0571.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_35_h5_zh.png
// module id = MN0d
// module chunks = 34